import React, { useState, useEffect } from 'react';

import { Map, control, HtmlMarker, Popup } from 'azure-maps-control';

import './azure-map.scss';
import { JOKI } from '../../JOKI';

export default function AzureMap(props) {
    const elId = props.elId !== undefined ? props.edId : 'AzureMapContainerId';

    const [mapObject, setMapObject] = useState(null);

    const [popup, setPopup] = useState(null);

    // Initialize Map
    useEffect(() => {
        const map = new Map(elId, {
            center: [props.lon !== undefined ? props.lon : 25, props.lat !== undefined ? props.lat : 61],
            zoom: props.zoom !== undefined ? props.zoom : 4,
            language: props.language !== undefined ? props.language : 'en-Us',
            style: props.style !== undefined ? props.style : 'road',
            authOptions: {
                authType: 'subscriptionKey',
                subscriptionKey: props.subscriptionKey !== undefined ? props.subscriptionKey : process.env.REACT_APP_AZURE_MAPS_KEY,
            },
        });

        map.events.add('ready', () => {
            const controlPosition = props.controlPosition !== undefined ? props.controlPosition : 'top-left';
            if (props.zoomControls !== false) {
                map.controls.add(new control.ZoomControl(), { position: controlPosition });
            }
            if (props.pitchControls !== false) {
                map.controls.add(new control.PitchControl(), { position: controlPosition });
            }
            if (props.compassControls !== false) {
                map.controls.add(new control.CompassControl(), { position: controlPosition });
            }
            if (props.styleControls !== false) {
                map.controls.add(new control.StyleControl(), { position: controlPosition });
            }
            setMapObject(map);
            setPopup(new Popup());
        });
        // eslint-disable-next-line
    }, []);

    // Draw Html Markers when markers change or MapObject state changes to something else than null
    useEffect(() => {
        if (mapObject !== null && props.htmlMarkers.length > 0) {
            drawHtmlMarkers();
        }
        // eslint-disable-next-line
    }, [props.htmlMarkers, mapObject]);

    useEffect(() => {
        return JOKI.on({
            key: 'moveMapToCoords',
            fn: e => {
                if (mapObject !== null) {
                    mapObject.setCamera({
                        center: [e.body[0], e.body[1]],
                        cameraOffset: [-1000, 0],
                        duration: 2000,
                        type: 'fly',
                    });
                }
            },
        });
    });

    function drawHtmlMarkers() {
        removeHtmlMarkers();
        props.htmlMarkers.forEach(markerData => {
            const marker = new HtmlMarker({
                color: markerData.color,
                text: markerData.text,
                draggable: false,
                htmlContent: markerData.htmlContent,
                // htmlContent: `<div class="map-marker ${markerState}" deviceCode="${
                //     markerData.id
                // }" onClick=><label>{text}</label></div>`,
                // // htmlContent: markerElm,
                position: markerData.coords,
            });

            if (markerData.onClick !== undefined && typeof markerData.onClick === 'function') {
                const html = marker.getOptions().htmlContent;
                const elm = document.createElement('div');
                elm.innerHTML = html.replace(/{text}/g, markerData.text || '').replace(/{color}/g, markerData.color || '');
                marker.setOptions({ htmlContent: elm });

                elm.addEventListener('click', () => {
                    markerData.onClick();
                });

                elm.addEventListener('mouseenter', e => {
                    if (popup !== null) {
                        popup.setOptions({
                            content: `<div class="map-popup">${markerData.text}</div>`,
                            position: markerData.coords,
                            pixelOffset: [0, -32],
                        });

                        popup.open(mapObject);
                    }
                });
                elm.addEventListener('mouseleave', () => {
                    if (popup !== null && popup.isOpen()) {
                        popup.close();
                    }
                });
            }
            mapObject.markers.add(marker);
        });
    }

    function removeHtmlMarkers() {
        if (mapObject !== null) {
            mapObject.markers.clear();
        }
    }

    return <div className="azure-map" id={elId} />;
}
